import React from "react";
import {
  Alert,
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormInput,
} from "shards-react";

import { login } from "../../backend/user";
import { UserContext, refresh } from "../../backend/userContext";
import { H } from "highlight.run";

class FormSignUp extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      email_check: true,
      password_check: true,
      error: undefined,
    };
    this.changeEmail = this.changeEmail.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hightlightLogin = this.hightlightLogin.bind(this);
  }

  errorband(error) {
    if (error != null) {
      const theme = "danger";
      return (
        <Alert className={"mt-2"} theme={theme}>
          {error}
        </Alert>
      );
    }
    return null;
  }

  async hightlightLogin(username) {
    H.identify(username);
  }

  async handleSubmit(event) {
    event.preventDefault();
    //console.log("Login user");
    if (this.state.email_check) {
      try {
        await login(
          { username: this.state.email, password: this.state.password },
          (data) => {
            this.setState({ error: null }, () => {
              refresh(this.context.setUser);
            });
          },
          (error) => {
            if (error === "authentication failed") {
              this.setState({
                error: "Usuario o contraseña incorrecta",
                email_check: false,
                password_check: false,
              });
            }
          }
        );
        // Highlight login
        await this.hightlightLogin(this.state.email, this.state.password);
      } catch (e) {
        console.log("Error", e);
        this.setState({
          error: "Error al iniciar sesión",
          email_check: false,
          password_check: false,
        });
      }
    } else {
      event.preventDefault();
    }
  }

  changeEmail(event) {
    let email = event.target.value;
    const expression =
      /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    if (expression.test(String(email).toLowerCase())) {
      this.setState({ email: email, email_check: true });
    } else {
      this.setState({ email: email, email_check: false });
    }
  }

  changePassword(event) {
    let password = event.target.value;
    this.setState({ password: password, password_check: true });
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div style={{ margin: 10 }}>
          <FormGroup>
            <FormInput
              size="lg"
              placeholder="correo"
              type="text"
              invalid={!this.state.email_check}
              onChange={(event) => this.changeEmail(event)}
            />
            <FormFeedback invalid={"true"}>
              {this.state.error ? "" : "Write a valid email"}
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <FormInput
              size="lg"
              placeholder="contraseña"
              type="password"
              invalid={!this.state.password_check}
              onChange={(event) => this.changePassword(event)}
            />
          </FormGroup>
          <FormFeedback invalid={"true"}>
            {this.state.error ? this.state.error : ""}
          </FormFeedback>
          <Button type="submit">Entrar</Button>
        </div>
        {this.errorband(this.state.error)}
      </Form>
    );
  }
}
export default FormSignUp;
